module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXRewardsTank/images/event_rewards_bg.0612d06f.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXRewardsTank/images/event_rewards_bg.jpg
// module id = 1066
// module chunks = 16